import { Path } from "utils/constants/paths.constants";

export const ORIGINAL_URI_TO_RESTORE = "original_uri_to_restore";
export const ACCESS_TOKEN = "access_token";
export const POST_LOGOUT_REDIRECT_URI = `${window.location.origin}${Path.Login}`;
export const GRAPHQL_PATH = "/graphql";

export const DECLINED_LEGAL_KEY = "declined_legal_acknowledgements";
export const LEGAL_ACKNOWLEDGEMENT_BYPASS_ERROR =
  "Legal notice is not accepted.";
